<div class="date-to-achievement-inline">

  <h4 *ngIf="field?.label" class="field-label">{{field.label}}</h4>

  <div *ngIf="sortedRows.length > 0" class="rows-list p-mb-3">
    <div *ngFor="let row of sortedRows" class="date-to-achievement-row">
      <span class="date-badge">{{ row.date | date: 'MM/dd/yyyy HH:mm' }}</span>
      <span class="achievement-id">
        Achievement: {{ getTitle(row) }}
        <a [routerLink]="'/achievements/' + row.achievementId" [ngStyle]="{ color: 'var(--primary-color)' }">({{ row.achievementId }})</a>
      </span>
      <p-button
        *ngIf="!readonly"
        icon="pi pi-times"
        styleClass="p-button-text p-button-danger p-button-sm remove-btn"
        (onClick)="removeRow(row.date)"
      ></p-button>
    </div>
  </div>
  <p *ngIf="sortedRows.length === 0" class="p-text-secondary p-mb-3" style="font-size:0.875rem;">
    No dates configured yet.
  </p>

  <div *ngIf="!readonly" class="p-d-flex p-ai-center p-mb-3" style="gap: 0.75rem;">
    <p-calendar
      [(ngModel)]="newDate"
      [showTime]="true"
      [monthNavigator]="true"
      [showButtonBar]="true"
      [showClear]="true"
      [hideOnDateTimeSelect]="false"
      placeholder="Date/Time"
      appendTo="body"
      [ngModelOptions]="{ standalone: true }"
    ></p-calendar>

    <p-autoComplete
      [(ngModel)]="newAchievement"
      [suggestions]="searchResults"
      (completeMethod)="searchAchievements($event)"
      (onSelect)="selectAchievement($event)"
      [field]="'title'"
      placeholder="Search achievements..."
      [style]="{'width': '280px'}"
      [inputStyle]="{'width': '100%'}"
      appendTo="body"
      [ngModelOptions]="{ standalone: true }"
    >
      <ng-template let-a pTemplate="item">
        <span>{{ a.title }}<span *ngIf="a.id" style="color:#868e96; margin-left:0.4rem;">({{ a.id }})</span></span>
      </ng-template>
    </p-autoComplete>

    <p-button
      label="+ Add"
      styleClass="p-button-outlined p-button-sm"
      (onClick)="addRow()"
    ></p-button>
  </div>

  <small *ngIf="!readonly && errorMessage" class="p-error" style="display:block; margin-bottom: 0.5rem;">
    {{ errorMessage }}
  </small>

</div>
